class ChatService {

    constructor() {
        this.baseUrl = null;
    }

    initialize(baseUrl) {
        this.baseUrl = baseUrl;
    }


    async streamChat(message, chatId,settings, onChunk,onDone,onError,onContext) {
        try {
            if (!this.baseUrl) {
                return false;
            }
            
            const eventSource = new EventSource(`${this.baseUrl}?query=${message}${chatId ? `&chatId=${chatId}` : ''}${settings ? `&settings=${JSON.stringify(settings)}&debug=true` : ''}`);
            var tempResponse = '';
            eventSource.onmessage = (event) => {
                // console.log("event",event);
                const data = JSON.parse(event.data);
                if (data?.content === '[DONE]') {
                    console.log("DONE",data?.chatId);
                    onDone(tempResponse,data?.chatId);   
                    eventSource.close();
                } else if(data?.context){
                    onContext(data?.context,data?.query);
                }else{
                    tempResponse += data.content;
                    onChunk(tempResponse);
                }
            };
            eventSource.onerror = (event) => {
                console.error('EventSource failed:', event);
                onError?.(event);
                eventSource.close();
            };
            return true;
        } catch (error) {
            console.error('Error streaming chat:', error);
            throw error;
        }
    }
}
//singleton pattern
export default new ChatService();
